import {
  Component,
  Inject,
  OnDestroy,
  OnInit,
  ViewEncapsulation
} from "@angular/core";
import { Subject } from "rxjs";
import { NavigationEnd, Router, RouterEvent } from "@angular/router";
import { DefaultActionFactory, DefaultActionFactoryToken } from "@core/redux/redux.module";
import {
  SessionHandlerService,
  SessionHandlerServiceToken,
  SessionManagerService,
  SessionManagerServiceToken
} from "@feature_core/session/session.module";

/**
 * @whatItDoes MKB 3D Secure static password management main app frameset.
 *
 * @howToUse
 *
 * Route handles the logic
 *
 * @description
 *
 * Routes the views
 * @selector none
 * @ngModule AppModule
 */
@Component({
  selector: "mkb-card3dsecure-app",
  templateUrl: "./app-frame.component.html",
  styles: [
    `
      :host {
        width: 100%;
      }
    `
  ],
  encapsulation: ViewEncapsulation.Emulated
})
export class AppFrameComponent implements OnInit, OnDestroy {

  protected _actionFactory: DefaultActionFactory;
  protected _destroy$: Subject<boolean> = new Subject<boolean>();

  public brand: any;

  public isIE11 = false;

  constructor(
    @Inject(DefaultActionFactoryToken) defaultActionFactory: DefaultActionFactory,
    @Inject(SessionManagerServiceToken) protected _sessionManager: SessionManagerService,
    @Inject(SessionHandlerServiceToken) protected _sessionHandler: SessionHandlerService,
    protected router: Router
  ) {
    this._actionFactory = defaultActionFactory;
  }

  ngOnInit() {
    this.isIE11 = !!navigator.userAgent.match(/Trident\/7\./);
    this.router.events.subscribe(this.navigationInterceptor.bind(this));
    this._sessionManager.init();
    this._sessionHandler.init();
  }

  ngOnDestroy(): void {
    this._destroy$.next(true);
    this._destroy$.unsubscribe();
  }

  doUnload() {
    // logout user on window close
    if (this.router && this.router.url === "/passwordmanagement/modify") {
      this._actionFactory.logout();
    }
  }

  navigationInterceptor(event: RouterEvent): void {
    if (event instanceof NavigationEnd) {
      window.scrollTo(0, 0);
    }
  }
}
